import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { WaitlistEntryRemoveModal } from './WaitlistEntryRemoveModal';

type WaitlistEntryRemoveModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type WaitlistEntryRemoveModalOpenerProps = {
   children: (renderProps: WaitlistEntryRemoveModalOpenerChildrenRenderProps) => ReactElement;
   entryId: number;
   patientFullName: string;
};

export const WaitlistEntryRemoveModalOpener = (props: WaitlistEntryRemoveModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <WaitlistEntryRemoveModal
               entryId={props.entryId}
               onClose={closeModal}
               patientFullName={props.patientFullName}
            />
         ) : null}
      </>
   );
};
